import { Route, Routes } from "react-router-dom";
import { PTLI0404001Q } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404001Q";
import { PTLI0404002S } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404002S";
import { PTLI0404003Q } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404003Q";
import { PTLI0404004S } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404004S";
import { PTLI0404006S } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404006S";
import { PTLI0404007Q } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404007Q";
import { PTLI0404008S } from "@/tra/tancis/ptli/comnmdle/comncd/PTLI0404008S";
import { PTLI0414001Q } from "@/tra/tancis/ptli/comnmdle/cntycd/PTLI0414001Q";
import { PTLI0414002S } from "@/tra/tancis/ptli/comnmdle/cntycd/PTLI0414002S";
import { PTLI0414003S } from "@/tra/tancis/ptli/comnmdle/cntycd/PTLI0414003S";
import { PTLI0415001Q } from "@/tra/tancis/ptli/comnmdle/regncd/PTLI0415001Q";
import { PTLI0415002S } from "@/tra/tancis/ptli/comnmdle/regncd/PTLI0415002S";
import { PTLI0415003S } from "@/tra/tancis/ptli/comnmdle/regncd/PTLI0415003S";
import { PTLI0416001Q } from "@/tra/tancis/ptli/comnmdle/curr/PTLI0416001Q";
import { PTLI0412001Q } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0412001Q";
import { PTLI0412002S } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0412002S";
import { PTLI0412003S } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0412003S";
import { PTLI0413001Q } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0413001Q";
import { PTLI0413002S } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0413002S";
import { PTLI0413003S } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0413003S";
import { PTLI0413004S } from "@/tra/tancis/ptli/comnmdle/doc/PTLI0413004S";
import { PTLI0409001Q } from "@/tra/tancis/ptli/comnmdle/aprvpath/PTLI0409001Q";
import { PTLI0409002S } from "@/tra/tancis/ptli/comnmdle/aprvpath/PTLI0409002S";
import { PTLI0409003S } from "@/tra/tancis/ptli/comnmdle/aprvpath/PTLI0409003S";
import { PTLI0409004Q } from "@/tra/tancis/ptli/comnmdle/aprv/PTLI0409004Q";
import { PTLI0409005S } from "@/tra/tancis/ptli/comnmdle/aprv/PTLI0409005S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const ComnMdleRouter = () => {
    return (
        <Routes>
            {/** ==================== Code Management Router START ==================== */}
            <Route path="/comncd/ptli0404001q" element={<PTLI0404001Q />} />
            <Route path="/comncd/ptli0404002s" element={<PTLI0404002S />} />
            <Route path="/comncd/ptli0404003q/:comnCd" element={<PTLI0404003Q />} />
            <Route path="/comncd/ptli0404004s/:comnCd" element={<PTLI0404004S />} />
            <Route path="/comncd/ptli0404006s/:comnCd" element={<PTLI0404006S />} />
            <Route path="/comncd/ptli0404007q/:comnCd/:cdVldVal" element={<PTLI0404007Q />} />
            <Route path="/comncd/ptli0404008s/:comnCd/:cdVldVal" element={<PTLI0404008S />} />

            <Route path="/cntycd/ptli0414001q" element={<PTLI0414001Q />} />
            <Route path="/cntycd/ptli0414002s" element={<PTLI0414002S />} />
            <Route path="/cntycd/ptli0414003s/:cntyCd" element={<PTLI0414003S />} />

            <Route path="/regncd/ptli0415001q" element={<PTLI0415001Q />} />
            <Route path="/regncd/ptli0415002s" element={<PTLI0415002S />} />
            <Route path="/regncd/ptli0415003s/:regnCd" element={<PTLI0415003S />} />

            <Route path="/curr/ptli0416001q" element={<PTLI0416001Q />} />

            {/** ==================== Code Management Router END ==================== */}

            {/** ==================== Doc Management Router START ==================== */}
            <Route path="/doc/ptli0412001q" element={<PTLI0412001Q />} />
            <Route path="/doc/ptli0412002s" element={<PTLI0412002S />} />
            <Route path="/doc/ptli0412003s/:dclaDocCd" element={<PTLI0412003S />} />

            <Route path="/doc/ptli0413001q" element={<PTLI0413001Q />} />
            <Route path="/doc/ptli0413002s/:dclaDocCd" element={<PTLI0413002S />} />
            <Route path="/doc/ptli0413003s/:param" element={<PTLI0413003S />} />
            <Route path="/doc/ptli0413004s" element={<PTLI0413004S />} />
            {/** ==================== Doc Management Router END ==================== */}

            {/** ==================== Approval Path Management Router START ==================== */}
            <Route path="/aprvpath/ptli0409001q" element={<PTLI0409001Q />} />
            <Route path="/aprvpath/ptli0409002s" element={<PTLI0409002S />} />
            <Route path="/aprvpath/ptli0409003s/:aprvPrcssPathMgmtId" element={<PTLI0409003S />} />
            {/** ==================== Approval Path Management Router END ==================== */}

            {/** ==================== Approval Router START ==================== */}
            <Route path="/aprv/ptli0409004q" element={<PTLI0409004Q />} />
            <Route path="/aprv/ptli0409005s/:aprvId/:usrDmnId" element={<PTLI0409005S />} />
            {/** ==================== Approval Router END ==================== */}
        </Routes>
    );
};
